<router-outlet></router-outlet>
<app-alert></app-alert>
<ngx-sonner-toaster position="top-right" richColors closeButton [duration]="5000" />


<ngx-spinner type="circle"  name="main">
  <img src="/assets/images/Loading-truck.gif" alt="Loading-truck" width="200px" />
</ngx-spinner>


<ngx-spinner
  name="load2"
  size="medium"
  type="ball-clip-rotate-multiple">
  <p style="color: white; font-size: 18px;">Please wait...</p>
</ngx-spinner>
